import { render, staticRenderFns } from "./StackedNearbyUniversityFilter.vue?vue&type=template&id=bb90cfa4"
import script from "./StackedNearbyUniversityFilter.vue?vue&type=script&lang=js"
export * from "./StackedNearbyUniversityFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports